var exports = {
  "k": "x93eb46d8--c70e93--container",
};

module.exports = exports;
